import classNames from 'classnames';
import React from 'react';

const PanelHeader = (props) => {
  return (
    <div className={ classNames('panel__header', props.className) }>
      { props.children }
    </div>
  );
};

export default PanelHeader;



// WEBPACK FOOTER //
// ./app/components/shared/panel/_PanelHeader.jsx